import { Dialog } from "@headlessui/react";
import { ModalFoterBox } from "../../components/box/Box";
import Button from "../../components/button/Button";
import { Modal, ModalProp } from "../../components/modal/Modal";
import { LinkMenus } from "../../model/LinkMenus";

export type LinkMenusDeleteModalProps = {
  linkMenus?: LinkMenus;
  handle: (val: LinkMenus) => void;
}

export const LinkMenusDeleteModal = ({
  open,
  toggle,
  closeOnClickOutside,
  linkMenus,
  handle,
}: ModalProp & LinkMenusDeleteModalProps) => {
  return (
    <>
      <Modal
        open={open}
        toggle={toggle}
        closeOnClickOutside={closeOnClickOutside}
      >
        <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all">
          {(linkMenus !== undefined) ? (
          <>
            <div className="px-2 pb-4 sm:p-4">
              <div className="text-center sm:mt-3">
                <Dialog.Title
                  as="h3"
                  className="text-left text-lg font-medium leading-6 text-gray-900"
                >
                  {linkMenus.name}
                </Dialog.Title>
              </div>
              <div className="mt-5">
                本当に削除しますか？
              </div>
            </div>
            <ModalFoterBox>
              <Button
                className="mx-2 mt-1 w-[132px]"
                outline
                onClick={toggle}
              >
                キャンセル
              </Button>
              <Button
                className="mt-1 mr-2 w-[132px]"
                color="red"
                onClick={() => handle(linkMenus)}>削除</Button>
            </ModalFoterBox>
          </>
          ): (<></>)}
        </Dialog.Panel>
      </Modal>
    </>
  );
}
